import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HttpService {
  constructor(private http: HttpClient) {}

  // GET request
  get(url: string): Observable<any> {
    return this.http.get(url);
  }

  // POST request
  post(url: string, data: any): Observable<any> {
    return this.http.post(url, data);
  }
  queryString(url: string, data: any): Observable<any> {
    return this.http.post(url, data);
  }

  genericApi(url: string, data: any): Observable<any> {
    return this.http.post(url + "/api/Generic/GetGenericResponse", data);
  }
}


